import React from 'react';
import { Button as UiButton, ButtonProps } from '@make-software/cspr-design';

type UIButtonProps = ButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = (props: UIButtonProps) => (
  <UiButton lineHeight={'xs'} {...props} hasOutline />
);
